export default [
	{  // 订单列表
		path: 'order',
		name: 'm_order',
		meta: {
			templateManage: {
				workType: 1,
				print: 'b_order_printtemplate',
				export: 'b_order_exporttemplate'
			},
			appView: {
				viewId: '90004',
				detailView: [{
					name: '详情-产品明细',
					viewId: '90014'
				}],
				auth: 'b_order_viewmanage'
			}
		},
		component: () => import('@/pages/sales/order_list')
	},
	{  // 订单产品列表
		path: 'order_product',
		name: 'm_order_product',
		meta: {
			templateManage: {
				workType: 41,
				print: 'b_order_product_printtemplate',
				export: 'b_order_product_exporttemplate'
			}
		},
		component: () => import('@/pages/sales/order_product_list')
	},
	{	 // 发货单列表
		path: 'order/deliver',
		name: 'm_order_deliver',
		meta: {
			templateManage: {
				workType: 32,
				print: 'b_order_deliver_printtemplate',
				export: 'b_order_deliver_exporttemplate'
			},
			appView: {
				viewId: '90029',
				detailView: [{
					name: '详情-发货明细',
					viewId: '90030'
				}],
				auth: 'b_order_deliver_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/sales/order_deliver_list')
	},
	{  // 订单发货明细列表
		path: 'order/deliver/product',
		name: 'm_order_deliver_product',
		meta: {
			templateManage: {
				workType: 33,
				print: 'b_order_deliver_product_printtemplate',
				export: 'b_order_deliver_product_exporttemplate'
			}
		},
		component: () => import('@/pages/sales/order_deliver_product_list')
	},
	{	 // 退货单列表
		path: 'order/return',
		name: 'm_order_return',
		meta: {
			templateManage: {
				workType: 53,
				print: 'b_order_return_printtemplate',
				export: 'b_order_return_exporttemplate'
			},
			appView: {
				viewId: '90040',
				detailView: [{
					name: '详情-退货明细',
					viewId: '90041'
				}],
				auth: 'b_order_return_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/sales/order_return_list')
	},
	{  // 订单退货明细列表
		path: 'order/return/product',
		name: 'm_order_return_product',
		meta: {
			templateManage: {
				workType: 54,
				print: 'b_order_return_product_printtemplate',
				export: 'b_order_return_product_exporttemplate'
			}
		},
		component: () => import('@/pages/sales/order_return_product_list')
	}
];